module.exports = __webpack_public_path__ + "static/media/banesco-thumbsup.5993728c.svg";